import { DependencyList, RefObject, useLayoutEffect, useRef } from 'react';

export function useResizeObserver<T extends HTMLElement>(
  cb: (entry: ResizeObserverEntry) => void,
  deps: DependencyList = [],
  externalRef?: RefObject<T | null>,
) {
  const ownRef = useRef<T>(null);
  const ref = externalRef || ownRef;
  const refCb = useRef(cb);
  refCb.current = cb;

  useLayoutEffect(() => {
    if (!ref.current) return;

    const el = ref.current;

    const observer = new ResizeObserver((entries) => {
      refCb.current(entries[0]!);
    });
    observer.observe(el);

    return () => {
      observer.unobserve(el);
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
}
